import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import PersonaFork from "@/pages/PersonaFork";
import Chat from "@/pages/Chat";
import Breathing from "@/pages/Breathing";
import Closing from "@/pages/Closing";
import InsightCard from "@/pages/InsightCard";
import History from "@/pages/History";
import InstallHint from "@/components/InstallHint";
import "@/App.css";

function Shell() {
  const location = useLocation();
  return (
    <div className="mx-auto relative min-h-[100dvh] max-w-md bg-still-bg text-still-fg grain">
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="min-h-[100dvh] flex flex-col"
        >
          <Routes location={location}>
            <Route path="/" element={<Home />} />
            <Route path="/start" element={<PersonaFork />} />
            <Route path="/chat/:sessionId" element={<Chat />} />
            <Route path="/breathe/:sessionId" element={<Breathing />} />
            <Route path="/closing/:sessionId" element={<Closing />} />
            <Route path="/card/:sessionId" element={<InsightCard />} />
            <Route path="/history" element={<History />} />
          </Routes>
        </motion.div>
      </AnimatePresence>
      <InstallHint />
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}

export default function App() {
  const [ready, setReady] = useState(false);
  useEffect(() => setReady(true), []);
  if (!ready) return null;
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}
